import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue')
      },
      {
        path: '/aliados',
        name: 'Aliados',
        component: () => import('../views/aliados/Aliados.vue')
      },
      {
        path: '/nuevo_aliado',
        name: 'Nuevo_aliado',
        component: () => import('../views/aliados/Nuevo_aliado.vue')
      },
      {
        path: '/aliado/:id_aliado',
        name: 'Aliado',
        component: () => import('../views/aliados/Aliado.vue')
      },
      {
        path: '/aliado/ficha/:id_aliado',
        name: 'Aliado_ficha',
        component: () => import('../views/aliados/Aliado_ficha.vue')
      },
      {
        path: '/aliado/info_basica/:id_aliado',
        name: 'Aliado_info_basica',
        component: () => import('../views/aliados/Aliado_info_basica.vue')
      },
      {
        path: '/aliado/info_secundaria/:id_aliado',
        name: 'Aliado_info_secundaria',
        component: () => import('../views/aliados/Aliado_info_secundaria.vue')
      },
      {
        path: '/aliado/contrato/:id_aliado',
        name: 'Contrato',
        component: () => import('../views/aliados/Contrato.vue')
      },
      {
        path: '/aliado/anexos/:id_aliado',
        name: 'Anexos',
        component: () => import('../views/aliados/Anexos.vue')
      },
      {
        path: '/cargar_anexo/:id_aliado/:id_tipo_anexo',
        name: 'Cargar_anexo',
        component: () => import('../views/aliados/Cargar_anexo.vue')
      },

      {
        path: '/aliado/solicitudes/:id_aliado',
        name: 'Solicitudes_piezas',
        component: () => import('../views/marketing/Solicitudes_piezas.vue')
      },
      {
        path: '/nueva_solicitud_pieza/:id_aliado',
        name: 'Nueva_solicitud',
        component: () => import('../views/marketing/Nueva_solicitud_pieza.vue')
      },
      {
        path: '/aliado/solicitud/:id_solicitud',
        name: 'Solicitud_piezas',
        component: () => import('../views/marketing/Solicitud_piezas.vue')
      },
      {
        path: '/panel_aliados',
        redirect: '/panel_aliados/1',
      },
      {
        path: '/panel_aliados/:page',
        name: 'Panel_aliados',
        component: () => import('../views/aliados/Panel_aliados.vue')
      },
      {
        path: '/usuarios',
        redirect: '/usuarios/1',
      },
      {
        path: '/usuarios/:page',
        name: 'Usuarios',
        component: () => import('../views/usuarios/Usuarios.vue')
      },
      {
        path: '/nueva_membresia',
        name: 'Nueva_membresia',
        component: () => import('../views/usuarios/Nueva_membresia.vue')
      },
      {
        path: '/usuario/:id_usuario',
        name: 'Usuario',
        component: () => import('../views/usuarios/Usuario.vue')
      },
      {
        path: '/ruta_usuarios',
        redirect: '/ruta_usuarios/1',
      },
      {
        path: '/ruta_usuarios/:page',
        name: 'Ruta_usuario',
        component: () => import('../views/usuarios/Ruta_membresias.vue')
      },
      {
        path: '/panel_usuarios',
        name: 'Panel_usuarios',
        component: () => import('../views/usuarios/Panel_usuarios.vue')
      },
      {
        path: '/agentes_usuarios',
        name: 'Agentes_usuarios',
        component: () => import('../views/usuarios/Agentes_usuarios.vue')
      },
      {
        path: '/beneficios_usuarios',
        name: 'Beneficios_usuarios',
        component: () => import('../views/usuarios/beneficios_usuarios/Beneficios_usuarios.vue')
      },
      {
        path: '/usuario/info_basica/:id_usuario',
        name: 'Usuario_info_basica',
        component: () => import('../views/usuarios/Usuario_info_basica.vue')
      },
      {
        path: '/beneficiarios/:id_usuario',
        name: 'Beneficiarios',
        component: () => import('../views/usuarios/Beneficiarios.vue')
      },
      {
        path: '/pago/:id_usuario',
        name: 'Pago',
        component: () => import('../views/usuarios/Pago.vue')
      },
      {
        path: '/anexos_membresia/:id_usuario',
        name: 'Anexos_membresia',
        component: () => import('../views/usuarios/Anexos_membresia.vue')
      },
      {
        path: '/cargar_anexo_membresia/:id_usuario/:id_tipo_anexo',
        name: 'Cargar_anexo_membresia',
        component: () => import('../views/usuarios/Cargar_anexo_membresia.vue')
      },
      {
        path: '/contrato_membresia/:id_usuario',
        name: 'Contrato_membresia',
        component: () => import('../views/usuarios/Contrato_membresia.vue')
      },
      {
        path: '/marketing',
        redirect: '/marketing/1'
      },
      {
        path: '/marketing/:page',
        name: 'Marketing',
        component: () => import('../views/marketing/Marketing.vue')
      },
      {
        path: '/impresos',
        redirect: '/impresos/1'
      },
      {
        path: '/impresos/:page',
        name: 'Marketing_impresos',
        component: () => import('../views/marketing/Marketing_impresos.vue')
      },
      {
        path: '/solicitudes',
        redirect: '/marketing/7'
      },
      {
        path: '/solicitudes/:tipo',
        name: 'Marketing_solicitudes_piezas',
        component: () => import('../views/marketing/Marketing_solicitudes_piezas.vue')
      },
      {
        path: '/panel_agentes',
        name: 'Panel_agentes',
        component: () => import('../views/aliados/Panel_agentes.vue')
      },
      {
        path: '/agentes',
        redirect: '/agentes/1'
      },
      {
        path: '/agentes/:page',
        name: 'Agentes',
        component: () => import('../views/agentes/Agentes.vue')
      },
      {
        path: '/pagos/:page',
        name: 'Pagos',
        component: () => import('../views/Pagos.vue')
      },
      {
        path: '/codigos_influencers/:page',
        name: 'Codigos_influencers',
        component: () => import('../views/Codigos_influencers.vue')
      },
      {
        path: '/membresias_influencers/:id_codigo',
        name: 'Membresias_influencers',
        component: () => import('../views/Membresias_influencers.vue')
      },
      {
        path: '/beneficios_aliados',
        name: 'Beneficios_aliados',
        component: () => import('../views/aliados/beneficios_aliados/Beneficios_aliados.vue'),
      },
      {
        path: '/solicitudes_aliados_plataforma',
        name: 'solicitudes_aliados_plataforma',
        component: () => import('../views/aliados/beneficios_aliados/Solicitudes_aliados_plataforma.vue')
      },
      {
        path: '/solicitudes_usuarios_plataforma',
        name: 'Solicitudes_usuarios_plataforma',
        component: () => import('../views/usuarios/beneficios_usuarios/Solicitudes_usuarios_plataforma.vue')
      },
      {
        path: '/usuarios_aliados',
        name: 'Usuarios_aliados',
        component: () => import('../views/aliados/beneficios_aliados/Usuarios_aliados.vue')
      },
      {
        path: '/top_5_aliados',
        name: 'Top_5_aliados',
        component: () => import('../views/aliados/Top_5_aliados.vue')
      },
    ]
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('../views/Auth.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
